(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reactive-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rx-compare')) {
  customElements.define('rx-compare', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.update = () => this.style.setProperty('--reveal', this.input.value + '%');
      this.input?.addEventListener('input', this.update);
    }
    disconnectedCallback() { this.input?.removeEventListener('input', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reactive-motion"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('rx-reaction')) {
  customElements.define('rx-reaction', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slider = this.querySelector('input');
      this.layer = this.querySelector('.rx-lab-reveal');
      this.playButton = this.querySelector('[data-play-button]');
      this.mask = this.querySelector('[data-activation-mask]');
      this.trails = this.querySelector('[data-rain-trails]');
      if (!this.slider || !this.layer || !this.mask) return;
      this.mode = 0; this.playing = false; this.visible = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const ns = 'http://www.w3.org/2000/svg';
      const el = (name, attrs = {}, parent = this.mask) => {
        const node = document.createElementNS(ns, name);
        Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, String(v)));
        parent.append(node); return node;
      };
      const clamp = n => Math.max(0, Math.min(1, n));
      const smooth = n => { n = clamp(n); return n * n * (3 - 2 * n); };
      const handId = this.layer.querySelector('[id^="RxHand-"]').id;
      const cloudId = this.layer.querySelector('[id^="RxCloud-"]').id;
      const contactId = this.layer.querySelector('[id^="RxContact-"]').id;
      const blob = (rx, ry, seed) => {
        const points = Array.from({ length: 40 }, (_, i) => {
          const a = i / 40 * Math.PI * 2;
          const r = .77 + .12 * Math.sin(a * 5 + seed) + .09 * Math.sin(a * 9 - seed) + .04 * Math.cos(a * 13);
          return [Math.cos(a) * rx * r, Math.sin(a) * ry * r];
        });
        return points.map((p, i) => (i ? 'L' : 'M') + p.map(n => n.toFixed(2)).join(' ')).join(' ') + 'Z';
      };
      this.build = () => {
        this.mask.replaceChildren(); this.trails.replaceChildren(); this.items = [];
        if (this.dataset.reaction === 'heat') {
          if (this.mode < 2) {
            const places = this.mode === 0 ? [[405, 400, -16, 1.14, 0]] :
              [[380, 355, -18, 1.05, 0], [594, 495, 22, 1.07, .23], [211, 673, -10, .9, .46], [590, 739, -25, 1.02, .66]];
            places.forEach(([x, y, angle, scale, delay]) => {
              const node = el('use', { href: '#' + handId, filter: 'url(#' + contactId + ')', transform: 'translate(' + x + ' ' + y + ') rotate(' + angle + ') scale(' + scale + ')', opacity: 0 });
              this.items.push({ node, delay, hand: true });
            });
          } else {
            [[352,343,89,113,0],[619,440,67,97,.18],[200,653,42,85,.36],[558,746,76,56,.50],[412,523,46,39,.65],[794,510,30,47,.75]].forEach(([x,y,rx,ry,delay],i)=>{
              const node=el('path',{d:blob(rx,ry,i+2),fill:'white',filter:'url(#'+cloudId+')',opacity:0});
              this.items.push({node,x,y,delay,angle:(i%2?1:-1)*13});
            });
          }
        } else if (this.mode === 0) {
          // Repeatable drop locations on shoulders, chest and sleeves.
          for (let i=0;i<34;i++) {
            const f=n=>{const v=Math.sin(n*127.1+73.7)*43758.5453;return v-Math.floor(v);};
            let x,y;
            if(i%4===0){x=150+f(i+1)*95;y=390+f(i+9)*440;}
            else if(i%4===1){x=764+f(i+2)*78;y=390+f(i+8)*430;}
            else{x=320+f(i+3)*360;y=210+f(i+6)*355;}
            const start=f(i+11)*.72, size=16+f(i+4)*25;
            const node=el('path',{d:blob(size,size*(.8+f(i+5)*.5),i),fill:'white',opacity:0});
            const line=el('line',{stroke:'#83aabd','stroke-width':2.7,'stroke-linecap':'round',opacity:0},this.trails);
            const ring=el('ellipse',{fill:'none',stroke:'#9dc2ce','stroke-width':1.8,opacity:0},this.trails);
            this.items.push({node,line,ring,x,y,start});
          }
        } else if (this.mode === 1) {
          [[620,365,102,75,0],[555,448,74,92,.12],[713,492,54,66,.27],[484,350,48,53,.43],[784,612,38,77,.58],[346,480,47,36,.69]].forEach(([x,y,rx,ry,delay],i)=>{
            const node=el('path',{d:blob(rx,ry,i+1),fill:'white',opacity:0});
            this.items.push({node,x,y,delay,angle:i*16});
          });
        } else {
          this.items.push({node:el('rect',{x:0,y:0,width:1000,height:1000,fill:'white',opacity:0}),full:true});
        }
        this.paint();
      };
      this.paint = () => {
        const p=Number(this.slider.value)/100;
        this.items.forEach(item=>{
          if(item.full){item.node.setAttribute('opacity',p);return;}
          if(item.line){
            const flight=(p-item.start)/.105;
            const wet=smooth((p-item.start-.105)/.20);
            item.node.setAttribute('transform','translate('+item.x+' '+item.y+') scale('+(.18+.82*wet)+')');
            item.node.setAttribute('opacity',wet);
            const active=flight>0&&flight<1&&(!this.playing||(this.phase%1)<.7), yy=item.y-155*(1-clamp(flight));
            item.line.setAttribute('x1',item.x-9*(1-clamp(flight)));
            item.line.setAttribute('x2',item.x-9*(1-clamp(flight))+1);
            item.line.setAttribute('y1',yy-18);item.line.setAttribute('y2',yy);
            item.line.setAttribute('opacity',active?.8:0);
            const ripple=(p-item.start-.105)/.085;
            item.ring.setAttribute('cx',item.x);item.ring.setAttribute('cy',item.y);
            item.ring.setAttribute('rx',4+clamp(ripple)*18);item.ring.setAttribute('ry',2+clamp(ripple)*7);
            item.ring.setAttribute('opacity',ripple>0&&ripple<1&&(!this.playing||(this.phase%1)<.7)?(1-ripple)*.7:0);
            return;
          }
          const a=smooth((p-item.delay)/(item.hand?.27:.3));
          item.node.setAttribute('opacity',a*.94);
          if(!item.hand)item.node.setAttribute('transform','translate('+item.x+' '+item.y+') rotate('+item.angle+') scale('+(.32+a*.68)+')');
        });
      };
      this.stop=()=>{this.playing=false;cancelAnimationFrame(this.frame);this.playButton.textContent=this.dataset.play;this.playButton.setAttribute('aria-pressed','false');};
      this.start=()=>{
        if(this.playing)return;
        this.playing=true;this.playButton.textContent=this.dataset.pause;this.playButton.setAttribute('aria-pressed','true');
        let last;
        this.tick=time=>{
          if(!this.playing)return;
          if(last&&this.visible&&!document.hidden){
            this.phase=(this.phase||0)+Math.min(time-last,80)/11000;
            const cycle=this.phase%1;
            // Accumulate local marks, hold, then fade before the next sequence.
            const amount=cycle<.69?cycle/.69:cycle<.83?1:1-(cycle-.83)/.17;
            this.slider.value=String(Math.round(clamp(amount)*100));this.paint();
          }
          last=time;this.frame=requestAnimationFrame(this.tick);
        };
        this.frame=requestAnimationFrame(this.tick);
      };
      this.playButton.addEventListener('click',()=>{this.manual=true;this.playing?this.stop():this.start();},options);
      this.slider.addEventListener('input',()=>{this.manual=true;this.stop();this.paint();},options);
      this.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>{
        this.mode=Number(button.dataset.mode);
        this.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        this.slider.value='0';this.phase=0;this.build();
        if(!this.reduced.matches){this.manual=true;this.start();}else{this.slider.value='80';this.paint();}
      },options));
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.stop();},options);
      document.addEventListener('visibilitychange',()=>{
        if(document.hidden){this.resume=this.playing;this.stop();}
        else if(this.resume&&this.visible&&!this.reduced.matches)this.start();
      },options);
      this.build();
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0].isIntersecting;
        if(!this.visible){this.wasPlaying=this.playing;this.stop();}
        else if(!this.reduced.matches&&(this.wasPlaying||(!this.manual&&this.dataset.autoplay==='true')))this.start();
      },{threshold:.15});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.stop?.();this.observer?.disconnect();this.controller?.abort();}
  });
}


  } catch(e) { console.error(e); }
})();
})();
